import { Box, Chip, Divider, Typography } from "@mui/material";
import { DialogContainer, DialogHeader } from "../../../components/exports";

// updated
export default function Support() {
    const phoneNumbers = ["021-72897000", "021-75425000"];

    return (
        <DialogContainer>
            <DialogHeader title="پشتیبانی پرشین سازه" />

            <Box sx={{ p: 2 }}>
                <Typography color="primary" sx={{ mb: 2 }}>
                    ساعات تماس با پشتیبانی
                </Typography>

                <Typography color="text.secondary" sx={{ mb: 2 }}>
                    شنبه تا چهارشنبه: 09:00 الی 18:00
                </Typography>

                <Typography color="text.secondary">
                    پنجشنبه ها: 10:00 الی 13:00
                </Typography>

                <Divider sx={{ my: 2 }} />

                <Typography color="primary" sx={{ mb: 2 }}>
                    شماره تماس های پشتیبانی
                </Typography>

                <Box sx={{ gap: 0.5, display: "flex" }}>
                    {phoneNumbers.map((pn) => {
                        return (
                            <a key={pn} href={`tel:${pn}`}>
                                <Chip
                                    size="medium"
                                    sx={{ cursor: "pointer" }}
                                    color="secondary"
                                    label={pn}
                                />
                            </a>
                        );
                    })}
                </Box>
            </Box>
        </DialogContainer>
    );
}
